/**
 * MTNLayout.js — MTN Nigeria workspace wrapper
 * Adds SSOT signal bar at top. Sidebar is provided by the main Layout.js (MTNSidebar).
 */
import React from "react";
import { Outlet } from "react-router-dom";
import MTNTopBar from "@/components/MTNTopBar";

export default function MTNLayout() {
  return (
    <div className="flex flex-col h-full">
      <MTNTopBar />
      <div className="flex-1 overflow-auto" style={{ background:"#060c1a" }}>
        <Outlet />
      </div>
    </div>
  );
}
